<template>
<div class="smart-form">
  <div class="smart-icon">
      <img src="../assets/bahn.png" width="120px"/>
     </div>
    <div class="screentime-hl">Wie viele Fernverkehrszüge der DB sind pünktlich?</div>
    
  <div class="screentime-form">
      <form v-if="hasQuizForm"> 
        <br>
           <div class="inner-form">
         <button class="gen_button" v-on:click.prevent="generateOption1">ca. 90%</button>
          &nbsp;&nbsp;
         <button class="gen_button" v-on:click.prevent="generateOption2">ca. 70%</button>
          &nbsp;&nbsp;
         <button class="gen_button" v-on:click.prevent="generateOption3">ca. 50%</button>
<br>
 <br>
</div></form>
  </div>
  <div v-if="hasChoosen" class="smartphone-dataviz">
  <br>
         <div class="screentime-description" v-html="quizDescription"> <br><br>
        </div>
    <br><br>
   <div class="dataviz-source"> Quelle: Deutsche Bahn</div>
  </div>
  </div>
</template>


<script>
export default {
  name: 'Quiz',
  props: {
    
  },
  data() {
        return {
            optionChoosen: "",
            hasChoosen: false,
            hasQuizForm:true       }     
    },
    computed: {
       
         quizDescription: function () {
        let smartAppMsg="";
        
            if (this.optionChoosen == "90") {
                smartAppMsg= "<b>Ca. 90% schafft leider nur der Regionalverkehr. </b><br><br> <b>89,6% </b> der Regionalzüge hatten im Juli 2022 weniger als 6 Minuten Verspätung. <br><br> <b>59,9% </b> der Fernverkehrszüge hatten im Juli 2022 weniger als 6 Minuten Verspätung. Im Fernverkehr schwankt die Pünktlichkeit seit 2010 zwischen 72,6% und 82%. So pünktlich wie 2020 mit 82% war der Fernverkehr seit 15 Jahren nicht mehr gewesen."
            }
            if (this.optionChoosen == "70") {
                smartAppMsg= "<b>Ca. 70% sind richtig.</b><br><br>Im Fernverkehr schwankt die Pünktlichkeit seit 2010 zwischen 72,6% und 82%. So pünktlich wie 2020 mit 82% war der Fernverkehr seit 15 Jahren nicht mehr gewesen. <br><br>Der Regionalverkehr ist deutlich pünktlicher. <b>89,6%</b> der Regionalzüge hatten im Juli 2022 weniger als 6 Minuten Verspätung. <br><br><b>59,9%</b> der Fernverkehrszüge hatten im Juli 2022 weniger als 6 Minuten Verspätung."
            }
            if (this.optionChoosen == "50") {
                smartAppMsg= "<b>Sie scheinen immer sehr großes Pech mit der Bahn zu haben.</b><br><br>Im Fernverkehr schwankt die Pünktlichkeit seit 2010 zwischen 72,6% und 82%. So pünktlich wie 2020 mit 82% war der Fernverkehr seit 15 Jahren nicht mehr gewesen. <br><br>Der Regionalverkehr ist deutlich pünktlicher. <b>89,6%</b> der Regionalzüge hatten im Juli 2022 weniger als 6 Minuten Verspätung. <br><br><b>59,9% </b> der Fernverkehrszüge hatten im Juli 2022 weniger als 6 Minuten Verspätung."
            }
                        
            return (smartAppMsg)
            }
            
       

    },
  methods: {
        generateOption1: function () {
            if (this.hasChoosen==true){
                this.hasChoosen = false;
                this.optionChoosen = "";
            } else {
            this.hasChoosen=true;
             this.hasQuizForm = false;
             this.optionChoosen = "90";
           
           }  
        },
         generateOption2: function () {
            if (this.hasChoosen==true){
                this.hasChoosen = false;
                this.optionChoosen = "";
            } else {
            this.hasChoosen=true;
             this.hasQuizForm = false;
             this.optionChoosen = "70";
           
           }  
        },
         generateOption3: function () {
            if (this.hasChoosen==true){
                this.hasChoosen = false;
                this.optionChoosen = "";
            } else {
            this.hasChoosen=true;
             this.hasQuizForm = false;
             this.optionChoosen = "50";
             console.log("50")
           
           }  
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import '../assets/styles.css';
</style>
